/**
 * @generated SignedSource<<51b3cf8c1d7512b15c24baab0bd08f81>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DirectoryAgentFeeTable_agent$data = {
  readonly fees: {
    readonly feesIncludeVat: boolean | null | undefined;
    readonly inventory: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly letOnly: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly management: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly managementWithTenantInPlace: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly otherFees: ReadonlyArray<{
      readonly amountPence: number | null | undefined;
      readonly label: string | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    }> | null | undefined;
    readonly renewal: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly rentCollection: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly rentCollectionWithTenantInPlace: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
    readonly tenantFind: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
      readonly sourceUrls: ReadonlyArray<string> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly name: string | null | undefined;
  readonly sources: {
    readonly feesIncludeVat: ReadonlyArray<string> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "DirectoryAgentFeeTable_agent";
};
export type DirectoryAgentFeeTable_agent$key = {
  readonly " $data"?: DirectoryAgentFeeTable_agent$data;
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryAgentFeeTable_agent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountPence",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percent",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceUrls",
  "storageKey": null
},
v3 = [
  (v0/*:: as any*/),
  (v1/*:: as any*/),
  (v2/*:: as any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feesIncludeVat",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DirectoryAgentFeeTable_agent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAgentFees",
      "kind": "LinkedField",
      "name": "fees",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "management",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "rentCollection",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "tenantFind",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "letOnly",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "renewal",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "inventory",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "managementWithTenantInPlace",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "rentCollectionWithTenantInPlace",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentOtherFee",
          "kind": "LinkedField",
          "name": "otherFees",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            (v2/*:: as any*/)
          ],
          "storageKey": null
        },
        (v4/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAgentSources",
      "kind": "LinkedField",
      "name": "sources",
      "plural": false,
      "selections": [
        (v4/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "LandlordDirectoryAgent",
  "abstractKey": null
};
})();

(node as any).hash = "61f3e6c64f88d6e6a722d54e937efaef";

export default node;
